/*
 * @Author: etong
 * @Date: 2021-11-01 17:51:32
 * @LastEditTime: 2025-02-20 18:15:04
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @Description:
 * @FilePath: \oak\src\store\modules\permission.js
 * Think first, Program later
 */
import { constantRouterMap } from '@/router'
import { getRouters } from '@/utils/auth' // getToken from cookie
import Layout from '@/views/layout/Layout'
import map from './routerMap'

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(routes, roles) {
  const res = []
  routes.forEach((route) => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      const { levle, component, children } = tmp
      if (component === 'Layout' && levle === 0) {
        tmp.component = Layout
      } else {
        tmp.component = loadView(route)
      }

      if (route.children != null && route.children && route.children.length > 0) {
        tmp.children = filterAsyncRouter(children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

// 动态导入routerMap模块的缓存
// const moduleCache = new Map()

const loadView = (route) => {
  const { is_group } = route
  if (is_group === 'Y' && route.children != null && route.children && route.children.length > 0) {
    return (resolve) => require([`@/views/level/index.vue`], resolve)
  } else {
    return map[route.name] // 适配二/三级菜单同时存在的情况
  }
}

// 根据路由名称猜测模块名称的简单函数
// function guessModuleName(routeName) {
//   // 系统相关
//   if (['warehouse', 'tax', 'black', 'system', 'role', 'user', 'shop'].some(keyword =>
//     routeName.toLowerCase().includes(keyword))) {
//     return 'system'
//   }

//   // 产品相关
//   if (['product', 'goods', 'brand', 'sku'].some(keyword =>
//     routeName.toLowerCase().includes(keyword))) {
//     return 'product'
//   }

//   // 订单相关
//   if (['order', 'purchase', 'sale'].some(keyword =>
//     routeName.toLowerCase().includes(keyword))) {
//     return 'order'
//   }

//   // 财务相关
//   if (['finance', 'tax', 'accounting', 'invoice'].some(keyword =>
//     routeName.toLowerCase().includes(keyword))) {
//     return 'finance'
//   }

//   // 默认返回system
//   return 'system'
// }

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { roles } = data
        let accessedRouters
        const routers = JSON.parse(getRouters())
        routers.push({ path: '*', redirect: '/401', hidden: true })
        // eslint-disable-next-line prefer-const
        accessedRouters = filterAsyncRouter(routers, roles)
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permission

